const prefix = 'admin';

export const getStreak = `${prefix}/streak-config`;
export const updateStreak = `${prefix}/streak-config`;
